import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/cloud-storage/")({
  staticData: {
    title: "common.cloudStorage",
  },
  loader: ({ params }) => {
    throw redirect({
      to: "/sources/fleets/$id/cloud-storage/databases",
      params,
      replace: true,
    });
  },
});
